import script from "./Sprachtechnik-Statistics-Orders.vue?vue&type=script&setup=true&lang=js"
export * from "./Sprachtechnik-Statistics-Orders.vue?vue&type=script&setup=true&lang=js"

import "./Sprachtechnik-Statistics-Orders.vue?vue&type=style&index=0&id=ac072b90&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac072b90"]])

export default __exports__